import { valueToCents } from "./currency.precision";

export const parseCurrencyInput = (
  input: string,
  precision: number = 2
): number | null => {
  if (!input) return null;

  // Remove all non-numeric and non-decimal separator characters
  input = input.trim().replace(/[^0-9.,-]/g, "");

  // Handle cases where both '.' and ',' are present - assume the last occurrence is the decimal separator
  const lastComma = input.lastIndexOf(",");
  const lastDot = input.lastIndexOf(".");
  let decimalSeparator = lastDot > lastComma ? "." : ",";

  // Normalize to use '.' as the decimal separator
  input = input.replace(/[,\.]/g, (match, offset) =>
    offset === (decimalSeparator === "." ? lastDot : lastComma) ? "." : ""
  );

  // Convert to float
  let numberValue = parseFloat(input);
  if (isNaN(numberValue)) return null;

  // Round to the specified precision
  return Math.round(
    valueToCents(parseFloat(numberValue.toFixed(precision)), precision)
  );
};

// console.log(parseCurrencyInput("1.234,56", 2)); // 1234.56
// console.log(parseCurrencyInput("€1,234.5678", 3)); // 1234.568
// console.log(parseCurrencyInput("1 234,9", 1)); // 1234.9
// console.log(parseCurrencyInput("-5,678.99", 2)); // -5678.99
// console.log(parseCurrencyInput("abc123.45xyz", 2)); // 123.45
// console.log(parseCurrencyInput("", 2)); // null
